import { ExtendedWalletClient } from "@sdk/index";
import {
  Abi,
  Chain,
  ContractFunctionName,
  ContractFunctionArgs,
  createPublicClient,
  fallback,
  http,
  PublicClient,
  ReadContractParameters,
  ReadContractReturnType,
} from "viem";

export const publicClient = (chain: Chain) => {
  // const transport = fallback([http(), http(chain.rpcUrls.fallback?.http?.[0])]);
  const rpcUrls = chain.rpcUrls.default.http;
  const fallbackRpcUrls = chain.rpcUrls.fallback?.http || [];
  const transport = fallback([...rpcUrls.map(url => http(url)), ...fallbackRpcUrls.map(url => http(url))]);
  return createPublicClient({
    chain: chain,
    transport,
  });
};

export async function readContract<
  const TAbi extends Abi | readonly unknown[],
  const TFunctionName extends ContractFunctionName<TAbi, "pure" | "view">,
>({
  walletClient,
  chain,
  args,
}: {
  walletClient: ExtendedWalletClient;
  chain: Chain;
  args: ReadContractParameters<TAbi, TFunctionName>;
}): Promise<ReadContractReturnType<TAbi, TFunctionName>> {
  const client = await getReadClient({ walletClient, chain });

  // Forward generics through to viem's original implementation
  return client.readContract(args);
}

export async function getReadClient({ walletClient, chain }: { walletClient: ExtendedWalletClient; chain: Chain }) {
  let client: PublicClient | ExtendedWalletClient = walletClient;

  // If wallet is a json-rpc client on a different network, fall back to a public client for the expected chain
  if (walletClient.account?.type === "json-rpc") {
    const walletChainId = await walletClient.getChainId();
    if (walletChainId !== chain.id) {
      client = publicClient(chain);
    }
  } else {
    client = publicClient(chain);
  }
  return client;
}
